import React      from 'react'; 
import portrait   from './portrait.module.css'
import landscape  from './publications.module.css';
import {Context}  from '../services/context.js'
import { Helmet } from 'react-helmet';
import PDFViewer  from '../components/pdf_viewer.jsx';
import cx         from 'classnames';

import PDFViewerPortrait  from '../components/pdf_viewer_portrait.jsx';

import 'react-pdf/dist/Page/TextLayer.css';
import 'react-pdf/dist/Page/AnnotationLayer.css';

const pdfPath   =  '/documents/Money for Modern Times.pdf';

const cx_title  = cx({[portrait.title]:  Context.portrait, [landscape.title]:   !Context.portrait});
const cx_header = cx({[portrait.header]: Context.portrait, [landscape.header]:  !Context.portrait});
const cx_text   = cx({[portrait.text]:   Context.portrait, [landscape.text]:    !Context.portrait});
const cx_ul     = cx({[portrait.ul]:     Context.portrait, [landscape.ul]:      !Context.portrait});
const cx_li     = cx({[portrait.li]:     Context.portrait, [landscape.li]:      !Context.portrait});
 
    export class Publications extends React.Component  
    { 

      //------------------------------------------------------------------
      //  Constructor
      //------------------------------------------------------------------
      constructor(props) 
      {
        super(props);
        this.component= "";
        this.state = {content_disabled: false}
      }  
  
      componentDidMount()
      {
        // console.log('Component did mount in About Us');
        //this.forceUpdate();
        window.scrollTo({top:0, left: 0, behavious: 'smooth'});
      };

      //------------------------------------------------------------------
      //
      //------------------------------------------------------------------
      changeVisible(mode) 
      {
        this.setState({content_disabled:mode})
      }


      //---------------------------------------------------------------------------
      //  Prepare for portrait devices first
      //---------------------------------------------------------------------------
      render()
      { 
        if (Context.portrait)
        {
            this.component = 
                <div className={portrait.backdrop}>
                    <Helmet>
                      <title>Back-Step Blockchain Publications</title>
                      <meta name="description" content="Related articles and white papers published by Blockchain Systems Pte. Ltd." />
                      <meta charset="utf-8" />
                    </Helmet>

   
                      <div className={cx_title}>
                      Recent White Paper
                      </div>

                      <div className={cx_text}>
                        <PDFViewerPortrait file={pdfPath}/>
                      </div>
                </div>
        }
        else
        //---------------------------------------------------------------------------
        //  Prepare for Landscape devices here 
        //---------------------------------------------------------------------------
        {
        this.component = 
          <div className={landscape.backdrop}  
              onMouseDown={(e) => 
              {
                 if (e.target === e.currentTarget) 
                {
                  this.changeVisible(true);
                }
              }}  
              onMouseUp={() => {
              // Restore the content when the mouse button is released.
              this.changeVisible(false);
              }}
              onContextMenu={(e) => e.preventDefault()}        
               >
 
              <Helmet>
                  <title>What we published</title>
                  <meta name="description" content="Publications about Back-Step Blockchain" />
                  <meta charset="utf-8" />
              </Helmet>

                <div className={landscape.container} 
                style={{visibility: this.state.content_disabled ? 'hidden' : 'visible', 
                        pointerEvents: this.state.content_disabled ? 'none' : 'auto', }}>

                  <div className={landscape.title_location}>
                    <div className={landscape.title_text}>
                      <p>Recent White Paper</p>
                    </div>
                  </div>
            
                  <div className={landscape.pdf_viewer}>
                    <PDFViewer file={pdfPath}></PDFViewer>
                  </div>
                </div>
          </div>
  
        }
        return this.component ;
      }
  
}
